// extracted by mini-css-extract-plugin
var _1 = "decimal-part-medium__UnmAf";
var _2 = "decimal-part-xlarge__DKffp";
export { _1 as "decimalPartMedium", _2 as "decimalPartXlarge" }
